import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ListingShowFileLibraryStateService {
  private _isShowFileLibrary = signal<boolean>(false);
  public isShowFileLibrary = this._isShowFileLibrary.asReadonly();

  public toggleShowFileLibrary(): void {
    this._isShowFileLibrary.set(!this.isShowFileLibrary());
  }

  public resetShowFileLibrary(): void {
    this._isShowFileLibrary.set(false);
  }
}
